import { createContext, useContext } from 'react'

/**
 * Whether a cell is being rendered inside the table head.
 *
 * Exists so `TableCell` can abbreviate a hand-written header on the dense mobile table.
 * Roughly a third of the tables here do not drive their headers from an `IFilter[]` —
 * they write `<TableCell>Total Loan Balance</TableCell>` directly, 204 such cells across
 * 49 files — and a cell has no other way to know whether its text is a column heading or
 * a value.
 *
 * Deriving it from the DOM instead was the alternative and is worse: it would mean a
 * layout-effect walking up to find a `thead`, per cell, on every render.
 */
const TableSectionContext = createContext<'head' | 'body'>('body')

export const TableSectionProvider = TableSectionContext.Provider

export const useIsTableHead = (): boolean => useContext(TableSectionContext) === 'head'

export default TableSectionContext
